import React, { memo, useCallback, useState } from 'react';
import { InteractionManager, StyleSheet, View } from 'react-native';
import Button from 'design-system/Button';
import { CardView } from 'design-system/CardView';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { NotificationsPermissionState } from 'hooks/useNotificationPermissionTypes';
import { useNotificationsPermissions } from 'hooks/useNotificationsPermissions';
import { useNotificationsPreferences } from 'features/settings/notifications/hooks/useNotificationsPreferences';
import { useAppSelector } from 'store/hooks';
import { isWeb } from '../../../constants';
import { selectFullCreditAlertsUnlocked } from '../selectors';
const PREFERENCE_KEY = 'alerts.credit_alerts.push';
const strings = {
    title: 'Turn on notifications',
    subtitle: 'Get real time updates on your credit alerts',
    button: 'Turn on',
};
const CreditAlertsNotificationCard = () => {
    const fullAlertsUnlocked = useAppSelector(selectFullCreditAlertsUnlocked);
    const { permissionState, activatePush } = useNotificationsPermissions('settings');
    const { pushNormalizedNotificationPreferences, updatePreferences } = useNotificationsPreferences(fullAlertsUnlocked);
    const [didTurnOn, setDidTurnOn] = useState(false);
    const isPushEnabled = permissionState === NotificationsPermissionState.Enabled;
    const isPreferenceOn = didTurnOn ||
        pushNormalizedNotificationPreferences[PREFERENCE_KEY] !== false;
    const handleTurnOn = useCallback(() => {
        setDidTurnOn(true);
        updatePreferences({ [PREFERENCE_KEY]: true });
        if (!isPushEnabled) {
            InteractionManager.runAfterInteractions(() => {
                activatePush('showAlert');
            });
        }
    }, [activatePush, isPushEnabled, updatePreferences]);
    if (isWeb)
        return null;
    if (!fullAlertsUnlocked)
        return null;
    if (permissionState === undefined)
        return null;
    if (isPushEnabled && isPreferenceOn)
        return null;
    return (<CardView withPadding noMarginTop style={styles.card}>
      <Text Text-16>{strings.title}</Text>
      <Spacer h={4}/>
      <Text TextThin-14 Secondary>
        {strings.subtitle}
      </Text>
      <Spacer h={16}/>
      <View style={styles.row}>
        <Button square brandReversed title={strings.button} onPress={handleTurnOn} containerStyle={styles.btn}/>
      </View>
    </CardView>);
};
export default memo(CreditAlertsNotificationCard);
const styles = StyleSheet.create({
    card: {
        marginHorizontal: rem(16),
        marginBottom: rem(16),
    },
    row: {
        flexDirection: 'row',
    },
    btn: {
        paddingHorizontal: rem(24),
    },
});
